































import { Component, Prop, Vue } from 'vue-property-decorator';
import echarts from 'echarts';
@Component({})
export default class EchartsColumn extends Vue {
  @Prop({ default: [] })
  private dataJson: any;
  @Prop({ default: [] })
  private columns: any;
  private small: string = 'small';
}
